import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class TickleAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const rotation = 5 * Math.PI / 180;
        const rotate = (sign: number) => {
            item.tweenTo((this.time || 0.15), Ease.sineInOut, {
                rotation: sign * rotation,
                repeat: -1,
                yoyo: true,
                onUpdate: () => this.updatePaperCut(item),
                onComplete: () => {
                    rotate(-sign);
                },
            });
        };
        rotate(1);
        cb();
    }
}
